<template>
	<v-menu :open-on-hover="hover" top offset-y>
		<template v-slot:activator="{ on, attrs }">
			<v-btn small :color="btnColor" :class="[...btnClassArray, hover ? 'no-click' : '']" :style="btnStyle" v-bind="attrs" v-on="on" icon>
				<v-icon>mdi-{{ iconName }}</v-icon>
			</v-btn>
		</template>
		<v-card :class="cardClassArray" :width="width" :elevation="elevation" :style="cardStyle">
			<p class="text-body-2" v-text="text" />
		</v-card>
	</v-menu>
</template>

<script>
export default {
	props: {
		text: {
			type: String,
			required: true,
		},
		btnClassArray: {
			type: Array,
			required: false,
			default: () => [],
		},
		cardClassArray: {
			type: Array,
			required: false,
			default: () => ["pa-2"],
		},
		btnColor: {
			type: String,
			required: false,
			default: "primary",
		},
		iconName: {
			type: String,
			required: false,
			default: "help-circle",
		},
		hover: {
			type: Boolean,
			required: false,
			default: true,
		},
		click: {
			type: Boolean,
			required: false,
			default: false,
		},
		cardStyle: {
			type: Object,
			required: false,
			default: null,
		},
		btnStyle: {
			type: Object,
			required: false,
			default: null,
		},
		elevation: {
			type: Number,
			required: false,
		},
		width: {
			type: Number,
			required: false,
		},
	},
}
</script>
